import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import React, {useContext, useRef, useState} from 'react'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {jwtDecode} from 'jwt-decode'

import AuthAPI from '../../../services/AuthAPI'
import AuthContext from '../../../contexts/AuthContext'
import Select from '../form/Select'
import Text from '../../../helpers/Text'
import {useStoreExecutions} from "../../../store/useStoreExecutions";
import ModalCustom from '../modal/ModalCustom'
import {TokenManager} from '../../../hooks/TokenManager'

const SideMenuUser = () => {
  const {isAuthenticated, setIsAuthenticated} = useContext(AuthContext)
  const {user, setUser} = useContext(AuthContext)
  const userRef = useRef(useContext(AuthContext))
  const setFlorist = useStoreExecutions(state => state.setFlorist);
  const [showSwitchModalError, setShowSwitchModalError] = useState(false);

  // Gestion de la déconnexion
  const handleLogout = () => {
    AuthAPI.logout(user.roles.indexOf('ROLE_ALLOWED_TO_SWITCH') >= 0)
    setIsAuthenticated(false)
  }

  // Gestion du changement de magasin
  const handleMagasin = (e) => {
      AuthAPI.switchShop(e.target.value)
          .then(({data: {token}}) => {
              const decodedToken = jwtDecode(token)
              TokenManager().setToken(token)
              userRef.current.setUser(decodedToken)
              setUser(decodedToken)
              setFlorist(decodedToken)
          })
          .catch(() => {
              e.target.value = userRef.current.user.CodeFl
              setShowSwitchModalError(true)
          })
  }

  return (
      isAuthenticated &&
      user && (
          <>
              <Col className={'bg-white mb-3 py-2 px-3'}>
                  <Row>
                      <Col lg={10}>
                          <span className={'font-weight-bold'}>
                              <FontAwesomeIcon
                                  icon={
                                      user.roles.find(
                                          (item) => item === 'ROLE_ADMIN',
                                      )
                                          ? ['fas', 'key']
                                          : ['fas', 'user']
                                  }
                                  color="var(--black-light)"
                                  className="mr-1"
                              />
                              {`${Text.CapitalizeAll(
                                  user.Prenom,
                              )} ${Text.CapitalizeAll(user.Nom)}
               - ${user.CodeFl} (${user.Contrat})`}
              </span>
            </Col>
            <Col lg={2}>
              <FontAwesomeIcon
                  icon={['fas', 'power-off']}
                  size="lg"
                  color="var(--black-light)"
                  onClick={handleLogout}
              />
            </Col>
          </Row>
          {user.roles.find((item) => item === 'ROLE_ADMIN') && (
              <Row>
                <Col>
                  <Select
                      controlId="magasinsSelect"
                      classNamesGroup="col p-0"
                      classNames="m-0 bg-white multi"
                      classNamesForm="mt-1 d-flex justify-content-center w-100"
                      onChange={(e) => handleMagasin(e)}
                      options={
                        <>
                          <option value={userRef.current.user.CodeFl}>
                            {userRef.current.user.CodeFl} - {userRef.current.user.Magasin}
                          </option>
                          {user.Multimagasins?.length > 0 &&
                              user.Multimagasins?.filter(
                                  (item) => item.codefl !== userRef.current.user.CodeFl,
                              ).map((item, index) => (
                                  <option key={index} value={item.codefl}>
                                    {item.codefl} - {item.magasin}
                                  </option>
                              ))}
                        </>
                      }
                  />
                </Col>
              </Row>
          )}
        </Col>

              <ModalCustom
                  show={showSwitchModalError}
                  onHide={() => setShowSwitchModalError(null)}
                  id="switch-error-modal"
                  size="md"
                  header
                  footer
                  headerTitle={
                      <>
                          Changement de magasin: <strong>erreur</strong>
                      </>
                  }
                  headerClassname={'bg-danger text-white'}
                  bodyClassname="py-5 px-sm-5 text-left"
                  content={
                      <p>
                          Une erreur est survenue lors du changement de magasin.
                          <br />
                          Veuillez réessayer ou nous contacter.
                      </p>
                  }
                  buttonsFooter={[
                      {
                          text: 'Fermer',
                          func: () => onHideModal(),
                      },
                  ]}
              />
          </>
      )
  )
}

export default SideMenuUser
